import React, { Component, Fragment } from 'react';
import ModifierGroup from './ModifierGroup';
export default class AvailableModifierGroups extends Component {
    constructor(props) {
        super(props);
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
    }

    removeIdsThatAreIncluded(modifiers, ids) {
        const includedMenuIds = new Set();

        // Collect menuIds that are included
        for (const item of Object.values(modifiers)) {
            if (item.menuId && item.includedQuantity === 1) {
                includedMenuIds.add(item.menuId);
            }
        }

        // Filter the provided ids
        return ids.filter(id => {
            const item = modifiers[id];

            if (!item) return true;

            return !(
                item.includedQuantity === 0 &&
                includedMenuIds.has(item.menuId)
            );
        });
    }

    generateJSXFromData() {
        // Set a variable we can increment, so that if the first item in the array is empty, we still have an active frame
        let firstFrame = 0;

        //Modifiers that are included for this pizza.
        var result = this.props.modifierGroups.map( (val,ind,arr) => {
            let shouldBeActive = (ind === firstFrame);
            //Add catch to only display the modifier group if it contains non-included items
            const filteredValMods = this.removeIdsThatAreIncluded(this.props.allModifiers, val.modifiers);
            if(val.modifiers.length > 0) {
                return <ModifierGroup
                            allModifiers={this.props.allModifiers}
                            key={ind}
                            index={ind}
                            isActive={shouldBeActive}
                            name={val.name}
                            modifiers={filteredValMods}
                            isTopping={val.isTopping}
                            isRadio={val.isRadio}
                            maxAllowed={val.maxAllowed}
                            minRequired={val.minRequired}
                            choices={this.props.choices}
                            setFirstHalf={this.props.setFirstHalf}
                            setSecondHalf={this.props.setSecondHalf}
                            setWhole={this.props.setWhole}
                            setExtra={this.props.setExtra}
                            setLight={this.props.setLight}
                            setNormal={this.props.setNormal}
                            removeModifier={this.props.removeModifier}
                            handleModifierQuantityChange={this.props.handleModifierQuantityChange}
                            increaseModifierQuantity={this.props.increaseModifierQuantity}
                            decreaseModifierQuantity={this.props.decreaseModifierQuantity}
                            selectedMainItem={this.props.selectedMainItem}
                            itemGroup={this.props.itemGroup}
                        />
            }else {
                // Increment firstFrame so the next real modifierGroup is active
                firstFrame++;
                return ''
            }
        });
        return result;
    }

    render() {
        return ( // Only return the accordion if there actually are modifierGroups
            this.props.modifierGroups.length > 0 ?
                <div>
                    <ul className="nav nav-tabs">
                        {
                            this.props.modifierGroups.map( (mod,i) => {
                                if(mod.modifiers.length) {
                                    if(i === 0) {
                                        return (
                                            <li className="nav-item" key={i}>
                                                <a className="nav-link active" href={`#${mod.name}`} id={`${mod.name}-tab`} role="tab" data-toggle="tab" aria-controls={mod.name} aria-expanded="true">{mod.name}</a>
                                            </li>)
                                    } else {
                                        return (
                                            <li className="nav-item" key={i}>
                                                <a className="nav-link" href={`#${mod.name}`} role="tab"
                                                   id={`${mod.name}-tab`} data-toggle="tab"
                                                   aria-controls={mod.name}>{mod.name}</a>
                                            </li>
                                        )
                                    }
                                }
                            })
                        }
                    </ul>
                    <div className="tab-content">
                        {this.generateJSXFromData()}
                    </div>
                </div>
                : ''
        );
    }
}
{/*<div className='container accordion mt-2 mb-4' id='availableModifierGroups'>*/}
{/*{this.generateJSXFromData()}*/}
{/*</div> : ''*/}